module.exports = __webpack_public_path__ + "static/media/toggleArrow.60d6dd85.svg";